import { render, staticRenderFns } from "./risk.vue?vue&type=template&id=13475ccc&scoped=true"
import script from "./risk.vue?vue&type=script&lang=js"
export * from "./risk.vue?vue&type=script&lang=js"
import style0 from "./risk.vue?vue&type=style&index=0&id=13475ccc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13475ccc",
  null
  
)

export default component.exports